/**
 * Indisponibilidade TEMPORÁRIA do armazenamento de sessões da API (Redis fora do ar).
 * A sessão do usuário pode estar viva: um 503 com este código nunca desloga, nem apaga
 * tokens, nem manda pro /login quando há sessão.
 *
 * Formato do corpo: `{ error: 'SESSION_STORE_UNAVAILABLE', message }` nas chamadas
 * autenticadas e `{ error: 'SESSION_STORE_UNAVAILABLE', Details }` (D maiúsculo) nas rotas
 * globais de login/refresh/desafio/nova senha/oauth.
 */
export const SESSION_STORE_UNAVAILABLE = 'SESSION_STORE_UNAVAILABLE';

/**
 * true para o HttpErrorResponse cru (status 503 + código no corpo) e também para o erro já
 * mapeado pelo CognitoService.mapApiError, que vira um Error com `name` igual ao código.
 */
export function isSessionStoreUnavailable(err: unknown): boolean {
  const e = err as { status?: unknown; name?: unknown; error?: { error?: unknown } } | null | undefined;
  return (
    (e?.status === 503 && e?.error?.error === SESSION_STORE_UNAVAILABLE) ||
    e?.name === SESSION_STORE_UNAVAILABLE
  );
}
